var render, staticRenderFns
import script from "./adminView.js?vue&type=script&lang=js&"
export * from "./adminView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097c7716')) {
      api.createRecord('097c7716', component.options)
    } else {
      api.reload('097c7716', component.options)
    }
    
  }
}
component.options.__file = "src/views/adminLayout/views/adminView/index.vue"
export default component.exports